import { z } from "zod";

const optionSchema = z.object({
    label: z.string(),
    value: z.union([z.string(), z.number()]),
});
const valueSchema = z.union([
    z.string().min(1),
    z.array(optionSchema).min(1),
    z.null(),
]);
const rowSchema = z.object({
    name: optionSchema,
    value: valueSchema,
    weight: z.number().min(1).max(10),
});
const businessType = z.object({
    businessType: z.literal("B2B"),
    icp: z.number(),
    behavior: z.number(),
    rows: z.array(rowSchema).min(1),
});
const personalSchema = z.object({
    businessType: z.literal("B2C"),
    state: z.union([
        z.array(optionSchema).min(1),
        z.object({
            label: z.string().min(1),
            value: z.array(optionSchema).min(1),
        }).required(),
    ]),
});
export const schnema = z.discriminatedUnion("businessType", [
    businessType,
    personalSchema,
]);
